const routers = [
    {
        path:'/accessKey/agent',
        name: 'Agent',
        component: resolve => require(['../views/accessKey/Agent'], resolve)
    },
    {
        path:'/accessKey/agentNew',
        name: 'AgentNew',
        component: resolve => require(['../views/accessKey/AgentNew'], resolve)
    },
    {
        path:'/accessKey/accessKey',
        name: 'AccessKey',
        component: resolve => require(['../views/accessKey/AccessKey'], resolve)
    },
    {
        path:'/accessKey/accessKeyNew',
        name: 'AccessKeyNew',
        component: resolve => require(['../views/accessKey/AccessKeyNew'], resolve)
    },  
    {
        path: '/accessKey/tokenExp',
        name: 'tokenExp',
        component: resolve => require(['../views/accessKey/TokenExp'], resolve)
    }
]
export default routers



// WEBPACK FOOTER //
// ./src/routers/accessKey.js